import React, { createContext, useContext, useEffect } from 'react';
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);


const db = getFirestore(app);
const storage = getStorage(app);

export const FirebaseContext = createContext({ auth, db, storage });

export const FirebaseProvider = ({ children }) => {
    useEffect(() => {
        // Set auth persistence to LOCAL (survives browser restarts)
        setPersistence(auth, browserLocalPersistence)

            .catch((error) => {
                console.error('🔐 Firebase: Error setting auth persistence:', error);
            });
    }, []);

    return <FirebaseContext.Provider value={{ auth, db, storage }}>{children}</FirebaseContext.Provider>;
};

export const useFirebase = () => {
    const context = useContext(FirebaseContext);
    if (!context) {
        throw new Error('useFirebase must be used within a FirebaseProvider');
    }
    return context;
};
